<template>
  <v-simple-table style="width: 100%;">
    <thead>
      <tr>
        <th class="text-left"></th>
        <th class="text-left">
          3 ตัวบน
        </th>
        <th class="text-left">
          2 ตัวบน
        </th>
        <th class="text-left">
          2 ตัวล่าง
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="game_round in game.game_rounds"
        :key="game_round.uuid"
        @click="gotoDetail(game_round)"
      >
        <td class="d-flex gap-2 items-center">
          <div>
            <v-img 
              width="20"
              :src="imagePath(game_round.game_id, game_round.name)"
            />
          </div>
          <span>
            {{ game_round.name }}
          </span>
        </td>
        <td>{{ game_round.round_rooms[0] && game_round.round_rooms[0].win_number && game_round.round_rooms[0].win_number.three_up || 'xxx' }}</td>
        <td>{{ game_round.round_rooms[0] && game_round.round_rooms[0].win_number && game_round.round_rooms[0].win_number.three_up.slice(-2) || 'xx' }}</td>
        <td>{{ game_round.round_rooms[0] && game_round.round_rooms[0].win_number && game_round.round_rooms[0].win_number.two_down || 'xx' }}</td>
      </tr>
    </tbody>
  </v-simple-table>
</template>
<script>
import {
  ROUTE_RESULT_DETAIL,
} from '@/const/route'
import { imagePath } from '@/plugins/mapImage' 

export default {
  props : {
    game : {
      type: Object,
      default: () => ({})
    },
  },
  methods: {
    imagePath,
    gotoDetail (game_round) {
      this.$router.push({ name: ROUTE_RESULT_DETAIL, params: { id: game_round.round_rooms[0].game_id }, query: {'layout': 'two'} });
    }
  }
}
</script> 